'use client'

import React from 'react'
import { Bullet, StepWrapper } from './step.style'
import { useTheme } from 'styled-components'

type ColorType = 'pink' | 'black'

interface IStepProps {
  steps: number
  set: number
  colorType?: ColorType
}

const StepBullet = ({ steps, set, colorType = 'pink' }: IStepProps) => {
  const theme = useTheme() as any
  const stepNum = []
  var length = steps

  const handleRenderColor = () => {
    switch (colorType) {
      case 'pink':
        return theme.base.shade.pink[0]
      case 'black':
        return '#000000'
      default:
        return theme.base.shade.pink[0]
    }
  }

  for (var i = 0; i < length; i++) {
    stepNum.push(i)
  }

  return (
    <StepWrapper>
      {stepNum.map((item: any) => (
        <Bullet key={item} set={set === item} colorType={handleRenderColor()} />
      ))}
    </StepWrapper>
  )
}

export default StepBullet
